import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { fmtMoney } from "@/lib/format";
import { Calculator } from "lucide-react";

export const CalculationDrawer = ({ open, onOpenChange, title, components = [], total, resultLabel = "Total", extra }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent className="w-full border-[#1E2D4A] bg-[#111A2E] text-slate-100 sm:max-w-md" data-testid="calculation-drawer">
      <SheetHeader>
        <SheetTitle className="flex items-center gap-2 text-slate-100">
          <Calculator className="h-4 w-4 text-cyan-400" /> {title}
        </SheetTitle>
      </SheetHeader>
      <div className="mt-6 space-y-1">
        {components.length === 0 && (
          <p className="text-sm text-slate-500">No cost components recorded for this period.</p>
        )}
        {components.map((c, i) => (
          <div key={i} className="rounded-lg border border-[#1E2D4A] bg-[#17233B]/60 p-3">
            <div className="flex items-start justify-between gap-3">
              <span className="text-sm text-slate-200">{c.label}</span>
              <span className="font-mono-fin text-sm font-semibold text-slate-100">{fmtMoney(c.amount)}</span>
            </div>
            {c.source && (
              <div className="mt-1 text-[11px] text-slate-500">
                <span className="font-medium text-slate-400">Source:</span> {c.source}
              </div>
            )}
          </div>
        ))}
      </div>
      {total !== undefined && (
        <div className="mt-4 flex items-center justify-between rounded-lg border border-cyan-500/30 bg-cyan-500/5 px-3 py-3">
          <span className="text-sm font-semibold uppercase tracking-wide text-cyan-300">{resultLabel}</span>
          <span className="font-mono-fin text-lg font-bold text-slate-50">{fmtMoney(total)}</span>
        </div>
      )}
      {extra}
    </SheetContent>
  </Sheet>
);
